/**
 * Immunization Service
 * Patient immunization records and vaccine tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReferenceDto } from './referenceDto';
import { PerformerDto } from './performerDto';
import { ProtocolAppliedDto } from './protocolAppliedDto';


export interface CreateImmunizationRequestDto { 
    /**
     * Patient identifier (subject)
     */
    patientId: string;
    /**
     * Immunization type element ID
     */
    elementId: string;
    /**
     * Immunization status
     */
    status: CreateImmunizationRequestDto.StatusEnum;
    /**
     * Date/time when the immunization was administered (ISO 8601). Optional for open immunizations.
     */
    occurrenceDateTime?: string;
    /**
     * Status reason element ID
     */
    statusReason?: string;
    /**
     * Body site element ID
     */
    site?: string;
    /**
     * Route of administration element ID
     */
    route?: string;
    /**
     * Dose quantity value
     */
    doseQuantity?: number;
    /**
     * Dose sequence element ID (1st, 2nd, booster, etc.)
     */
    sequence?: string;
    /**
     * Performer information
     */
    performer?: PerformerDto;
    /**
     * Reason code element IDs
     */
    reasonCode?: Array<string>;
    /**
     * Reason references
     */
    reasonReference?: Array<ReferenceDto>;
    /**
     * Protocol applied
     */
    protocolApplied?: ProtocolAppliedDto;
    /**
     * Vaccine lot number
     */
    lotNumber?: string;
    /**
     * Vaccine manufacturer element ID
     */
    manufacturer?: string;
    /**
     * Location ID where immunization was administered
     */
    locationId?: string;
    /**
     * Vaccine expiration date (ISO 8601)
     */
    expirationDate?: string;
    /**
     * When the immunization was recorded (ISO 8601)
     */
    recorded?: string;
    /**
     * Whether this is from primary source
     */
    primarySource?: boolean;
    /**
     * Clinical notes about the immunization
     */
    note?: Array<string>;
    /**
     * Additional metadata
     */
    metadata?: any;
}
export namespace CreateImmunizationRequestDto {
    export type StatusEnum = 'completed' | 'entered-in-error' | 'not-done';
    export const StatusEnum = {
        Completed: 'completed' as StatusEnum,
        EnteredInError: 'entered-in-error' as StatusEnum,
        NotDone: 'not-done' as StatusEnum
    };
}


